@use "styles/abstracts/variables" as v;
@use "styles/abstracts/theme" as theme;
@use "styles/abstracts/mixins/common" as c;
@use "./base/reset" as r;
@forward "./modules/animations";

@include c.use-layer(total-tracking-reset) {
  @include r.reset;
}

.app-container-total-tracking {
  // Default matches map night theme (DEFAULT_MAP_THEME)
  @include theme.theme-dark-tokens;

  font-size: 16px;
  line-height: 24px;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  font-family: v.$primary-font;
  color: v.$default-text-color;
  font-style: normal;
  min-height: 560px;
  height: 900px;
  max-height: 900px;
  display: flex;
  position: relative;

  // Setup .app-container as container query context
  container-type: inline-size;
  container-name: app;

  @include c.containerMedia(v.$js-defined-mobile-breakpoint) {
    height: 700px;
    max-height: 700px;
  }

  &[data-theme="dark"] {
    @include theme.theme-dark-tokens;
  }

  &[data-theme="light"] {
    @include theme.theme-light-tokens;
  }
}

.app-root-total-tracking {
  flex-grow: 1;
}

.app-modal-total-tracking {
  position: absolute;
  inset: 0;
  z-index: v.$z-index-ui-popup;
  pointer-events: none;

  &:not(:empty) {
    pointer-events: auto;
  }
}
